// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__dyRQi","toggle--active":"Toggle_toggle--active__zVW9w","toggle-sphere":"Toggle_toggle-sphere__y6YyO"};